import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e09c6ca8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "logs" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "pagination" }

import {reactive, ref, toRaw} from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'template',
  setup(__props) {

const currentPage = ref(4)
const pageSize = ref(50)
const small = ref(false)
const background = ref(true)
const disabled = ref(false)


// 定义变量内容
const state = reactive({
  form: {
    name: '',
    email: '',
    autograph: '',
    occupation: '',
    phone: '',
    sex: '',
    phone1: '',
    phone2: '',
    phone3: '',
    phone4: '',
    phone5: '',
    phone6: '',
  },
});

/*分页显示多少*/
const handleSizeChange = (val: number) => {
  console.log(`${val} items per page`)
}
/*当前第几页*/
const handleCurrentChange = (val: number) => {
  console.log(`current page: ${val}`)
}
/*新增*/
const handleAdd = () => {

}
/*编辑*/
const handleEdit = (index: number , row:object) => {
  console.log(index)
  console.log(toRaw(row))
}
/*删除*/
const handleDelete = (index: number , row:object) => {
  console.log(index)
  console.log(toRaw(row))
}
/*表单*/
const handleTableData = () => {
  return [
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    }
    ,{
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },{
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    },
    {
      date: '2016-05-03',
      name: 'Tom',
      address: 'No. 189, Grove St, Los Angeles',
    }
  ]
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        model: state.form,
        size: "default",
        "label-width": "100px",
        class: "mt35 mb35"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, { gutter: 35 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 12,
                md: 8,
                lg: 6,
                xl: 4,
                class: "mb20"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "姓名" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: state.form.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.form.name) = $event)),
                        placeholder: "请输入姓名",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 12,
                md: 8,
                lg: 6,
                xl: 4,
                class: "mb20"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "姓名" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: state.form.name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.form.name) = $event)),
                        placeholder: "请输入姓名",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 12,
                md: 8,
                lg: 6,
                xl: 4,
                class: "mb20"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "姓名" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: state.form.name,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.form.name) = $event)),
                        placeholder: "请输入姓名",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 12,
                md: 8,
                lg: 6,
                xl: 4,
                class: "mb20"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "姓名" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: state.form.name,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.form.name) = $event)),
                        placeholder: "请输入姓名",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 12,
                md: 8,
                lg: 6,
                xl: 4,
                class: "mb20"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "姓名" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: state.form.name,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.form.name) = $event)),
                        placeholder: "请输入姓名",
                        clearable: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                xs: 24,
                sm: 24,
                md: 24,
                lg: 24,
                xl: 24
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, { type: "primary" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_SvgIcon, { name: "iconfont icon-biaodan" }),
                          _createTextVNode(" 更新个人信息 ")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_table, {
        data: handleTableData(),
        stripe: "",
        border: "",
        height: "100%",
        "show-header": "",
        "header-align": "center",
        width: "100%"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            prop: "date",
            label: "Date",
            width: "180",
            align: "center",
            "header-align": "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "name",
            label: "Name",
            width: "180",
            align: "center",
            "header-align": "center"
          }),
          _createVNode(_component_el_table_column, {
            prop: "address",
            label: "Address",
            width: "280",
            align: "center",
            "header-align": "center"
          }),
          _createVNode(_component_el_table_column, { align: "center" }, {
            header: _withCtx(() => [
              _createTextVNode(" 操作 ")
            ]),
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                size: "small",
                onClick: ($event: any) => (handleEdit(scope.$index, scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Edit")
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_el_button, {
                size: "small",
                type: "danger",
                onClick: ($event: any) => (handleDelete(scope.$index, scope.row))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Delete")
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_pagination, {
        "current-page": currentPage.value,
        "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((currentPage).value = $event)),
        "page-size": pageSize.value,
        "onUpdate:pageSize": _cache[6] || (_cache[6] = ($event: any) => ((pageSize).value = $event)),
        "page-sizes": [50, 100, 150, 200],
        small: small.value,
        disabled: disabled.value,
        background: background.value,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 400,
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "small", "disabled", "background"])
    ])
  ]))
}
}

})